export default __webpack_public_path__ + "static/X04-ad8eccb63d94a77e9f1caa62f7b2dbaf.png";